import parsePhoneNumber from 'libphonenumber-js';

const contactPhoneNumber = parsePhoneNumber('+18564859703')!;

export const CONTACT_INTERNATIONAL_PHONE_NUMBER = contactPhoneNumber.formatInternational();
export const CONTACT_NATIONAL_PHONE_NUMBER = contactPhoneNumber.formatNational();
export const CONTACT_URI_PHONE_NUMBER = contactPhoneNumber.getURI();
export const SUPPORT_URL = 'https://www.metropolis.io/support';
